import { Component, Input } from '@angular/core';
import { CartItemContext } from '@spartacus/cart/base/root';
import { CartItemComponent, CartItemContextSource } from '@spartacus/cart/base/components';

@Component({
  selector: 'cx-cart-item',
  templateUrl: './cart-item.component.html',
  styleUrl: './cart-item.component.scss',
  providers: [CartItemContextSource, { provide: CartItemContext, useExisting: CartItemContextSource }],
  standalone: false,
})
export class CustomCartItemComponent extends CartItemComponent {
  @Input() isOrder = false;

  getVariantOptionQualifiers(item: any): any[] {
    return item.product?.baseOptions[0]?.selected?.variantOptionQualifiers ?? [];
  }

  getStockLevel(item: any): boolean {
    return item?.product?.stock.stockLevel >= 0;
  }
}
